// extracted by mini-css-extract-plugin
export default {"component":"Left_component__CZpif","blockSettings":"Left_blockSettings__gwZzX","logoStyling":"Left_logoStyling__JYFkz","winAndLostStyling":"Left_winAndLostStyling__ip-NC"};